import { Flex, SkeletonBox, SkeletonCircle, Space } from '@billy/design-system'
import { ReactElement } from 'react'

import * as Styled from './styles'

const SKELETON_ROW_COUNT = 5

export const NavigationMenuSkeleton = (): ReactElement => (
  <Styled.Wrapper>
    {Array.from({ length: SKELETON_ROW_COUNT }, (_, index) => (
      <div key={index}>
        <Flex alignItems="center">
          <SkeletonCircle size={24} data-testid="icon-menu-skeleton" />
          <Space size="s8" horizontal />
          <SkeletonBox height={14} width={150} data-testid="item-menu-skeleton" />
        </Flex>
        {index < SKELETON_ROW_COUNT - 1 && <Space size="s16" />}
      </div>
    ))}
  </Styled.Wrapper>
)
